import apiClient from "../../../apiClient";
import { useAppContext } from "../../../context";
import VirtualTable from "../../../components/custom/VirtualTable";
import { getTsDate } from "../../../utils";
import useSWR from "swr";

const fetcher = async (key: string) => {
    try {
        const res = await apiClient.get(key);
        return res.data;
    } catch (err) {
        return [];
    }
}

interface DockDoorItem {
    s_dock_door: string;
    s_mawb_id: string;
    s_assignee: string;
    s_mawb: string;
    s_status: string;
    s_trucking_company: string;
    s_trucking_driver: string;
    s_transaction_id: string;
}

export default function DockDoors({
    activeTab
}) {

    const { user } = useAppContext();
    const { s_unit } = user;
    const key = activeTab === 'dockDoors' ? `/dev/dock-doors/${s_unit}` : null;
    const { data: dockDoors, mutate } = useSWR(key, fetcher, {
        refreshInterval: 10000
    });

    const clearDockDoor = async (item: DockDoorItem) => {
        const { s_dock_door, s_transaction_id, s_mawb_id } = item;
        try {
            await apiClient.post(`/clear-dock-door`, {
                s_dock_door,
                s_unit,
                s_transaction_id,
                s_modified_by: user.s_email,
                t_modified: getTsDate()
            });
            const filtered = dockDoors.filter((item: DockDoorItem) => item.s_mawb_id !== s_mawb_id);
            mutate(filtered);
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <div>
            <VirtualTable
                data={dockDoors}
                mapping={[{
                    name: 'Door',
                    value: 's_dock_door'
                }, {
                    name: 'Agent',
                    value: 's_assignee',
                    email: true
                }, {
                    name: 'MAWB',
                    value: 's_mawb',
                    s_mawb: true
                }, {
                    name: 'Status',
                    value: 's_status'
                }, {
                    name: 'Company',
                    value: 's_trucking_company'
                }, {
                    name: 'Driver',
                    value: 's_trucking_driver'
                }, {
                    name: '',
                    value: 'fas fa-trash',
                    icon: true,
                    function: (item: DockDoorItem) => clearDockDoor(item)
                }]}
            />
        </div>
    );
}